<template>
  <div id="step-info" :class="{ small: isSmallScreen }">
    <StepInfoHeader :showHeaderHelperIcon="showHeaderHelperIcon"/>

    <div>
      <slot/>
    </div>

    <StepInfoFooter
      @click="handleClick"
      :btnText="btnText"
      :classBtn="classBtn"
      :iconName="iconName"
      :showIcon="showIcon"
    />
  </div>
</template>

<script>
import StepInfoFooter from './StepInfoFooter.vue';
import StepInfoHeader from './StepInfoHeader.vue';

export default {
  name: 'onboarding-step-info',
  components: { StepInfoFooter, StepInfoHeader },
  props: {
    btnText: {
      type: String,
      required: true,
    },
    iconName: {
      type: String,
      default: 'camera',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showHeaderHelperIcon: {
      type: Boolean,
      default: true,
    },
    classBtn: {
      type: String,
      default: 'primary',
    },
  },
  data: () => ({
    isSmallScreen: false,
  }),
  methods: {
    handleClick(evt) {
      this.$emit('btnClick', evt);
    },
  },
  mounted() {
    const pageHeight = document.getElementById('step-info').clientHeight;
    const { path } = this.$route;
    const workspaces = path.split('/');
    const toAddScroll = ['selfie', 'camera-error', 'entrada', 'completo'];

    let included = false;

    for (let i = 0; i < workspaces.length; i += 1) {
      if (toAddScroll.includes(workspaces[i])) {
        included = true;
        break;
      }
    }

    if (pageHeight <= 480
      || (workspaces[2] === 'completo' && pageHeight <= 640)
      || (included && pageHeight <= 576)) {
      this.isSmallScreen = true;
    }
  },
};
</script>

<style lang="scss" scoped>
  #step-info {
    display: grid;
    grid-template-rows: 12vh 76vh 12vh;

    padding: 0 24px;
    height: 100vh;

    &.small {
      display: block;

      .footer {
        margin: 20px 0 20px 0;
      }
    }
  }
</style>
